// @noflow
import { Prompt, withRouter } from 'react-router';

import { injectIntl } from 'react-intl';
import messages from './intl';
import PropTypes from 'prop-types';
import * as React from 'react';

const Component = withRouter(
    injectIntl(
        class UnsavedChangesModal extends React.Component {
            static props = {
                showModal: PropTypes.bool.isRequired
            };

            render() {
                const { intl, showModal } = this.props;
                return <Prompt message={intl.formatMessage(messages.description)} when={showModal} />;
            }
        }
    )
);

export default Component;



// WEBPACK FOOTER //
// ./src/components/widgets/unsaved-changes-modal/index.js